import { ThemeEvents } from './events.js';

class ProductFinanceComponent extends HTMLElement {
	#controller = new AbortController();

	connectedCallback() {
		const { signal } = this.#controller;

		this.#bindVariantEvents(signal);
		this.#bindToggle(signal);
	}

	disconnectedCallback() {
		this.#controller.abort();
	}

	#bindVariantEvents(signal) {
		const section = this.closest('.shopify-section, dialog');
		if (!section) return;

		section.addEventListener(
			ThemeEvents.variantUpdate,
			(event) => {
				const variant = event.detail.resource;
				if (!variant || !variant.price) return;
				this.#updatePrices(variant.price);
			},
			{ signal }
		);
	}

	#bindToggle(signal) {
		const btn = this.querySelector('.product-finance__learn-more');
		if (!btn) return;

		btn.addEventListener('click', this.#handleToggle, { signal });
	}

	#handleToggle = () => {
		const details = this.querySelector('.product-finance__details');
		const btn = this.querySelector('.product-finance__learn-more');
		if (!details || !btn) return;

		const isOpen = details.hasAttribute('open');
		if (isOpen) {
			details.removeAttribute('open');
			btn.setAttribute('aria-expanded', 'false');
		} else {
			details.setAttribute('open', '');
			btn.setAttribute('aria-expanded', 'true');
		}
	};

	/**
	 * Update widget prices when variant changes.
	 * @param {number} priceInCents
	 */
	#updatePrices(priceInCents) {
		this.dataset.variantPrice = String(priceInCents);

		// Klarna uses cents/pence directly
		const klarnaEl = this.querySelector('klarna-placement');
		if (klarnaEl) {
			klarnaEl.setAttribute('data-purchase-amount', String(priceInCents));
		}

		// Clearpay uses decimal pounds
		const clearpayEl = this.querySelector('square-placement');
		if (clearpayEl) {
			clearpayEl.setAttribute('data-amount', (priceInCents / 100).toFixed(2));
		}

		this.#refreshWidgets();
	}

	#refreshWidgets() {
		try {
			if (window.Klarna && window.Klarna.OnsiteMessaging) {
				window.Klarna.OnsiteMessaging.refresh();
			}
		} catch (_) {
			// Klarna SDK handles attribute changes via MutationObserver
		}

		try {
			if (window.Square && window.Square.marketplace) {
				window.Square.marketplace.refresh();
			}
		} catch (_) {
			// Square SDK handles attribute changes via MutationObserver
		}
	}
}

if (!customElements.get('product-finance-component')) {
	customElements.define('product-finance-component', ProductFinanceComponent);
}
